// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"195":"login1","289":"login43","577":"login3"}[chunkId] + "." + {"195":"c56adde9","289":"80c2a285","577":"7740ff9a"}[chunkId] + ".css";
};